import * as z from "zod";

export const getOpenShipmentValue = {
  name: "getOpenShipmentValue" as const,
  input: z.object({}),
  output: z.object({
    values: z.array(z.object({ amount: z.number(), currency: z.string() })),
  }),
};
